<ambita-cadastre-report-wrapper class="ambita-cadastre-report-wrapper">
  <ambita-report-print-toolbar if="{ !opts.multipleReport }"/>
  <report-header date="{ opts.date }" if="{ !opts.multipleReport }"/>
  <ambita-loading-indicator show="{ loading }" loading-text="{ i18n.propertyLookup.loading }"/>
  <ambita-cadastre-report show="{ !loading }" has-cadastre-click-handler="{ hasCadastreClickHandler }"
                          summary-link-handler="{ opts.summaryLinkHandler }"
                          property-address-key="{ opts.propertyAddressKey }"/>
  <ambita-cadastre-report-disclaimer/>

  <script>
    import './cadastreReport.tag';
    import './cadastreReportDisclaimer.tag';
    import '../common/reportHeader.tag';
    import '../common/loadingIndicator.tag';
    import '../reportPrintToolbar/reportPrintToolbar.tag';
    import './cadastreReport.scss';
    import './cadastreReportPrint.scss';
    import { init } from './cadastreReportWrapperController';

    init(this);
  </script>
</ambita-cadastre-report-wrapper>
